export const locale = {
  clock: 'Time Widget',
};
